import { render, staticRenderFns } from "./CreateAllowanceForAllowanceBreakdownTypeFailed.vue?vue&type=template&id=6c9bbe1a"
import script from "./CreateAllowanceForAllowanceBreakdownTypeFailed.vue?vue&type=script&lang=js"
export * from "./CreateAllowanceForAllowanceBreakdownTypeFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports